import { render } from "./IconBlueFolder.vue?vue&type=template&id=e63fc452"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBlueFolder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e63fc452"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e63fc452', __exports__)) {
    api.reload('e63fc452', __exports__)
  }
  
  module.hot.accept("./IconBlueFolder.vue?vue&type=template&id=e63fc452", () => {
    api.rerender('e63fc452', render)
  })

}


export default __exports__